export interface ParsedCertificationDeepLink {
  present: boolean;
  certificationId: number | null;
  invalid: boolean;
}

function isPositiveSafeInteger(value: unknown): value is number {
  return typeof value === "number" && Number.isSafeInteger(value) && value > 0;
}

export function parseCertificationDeepLink(search: string): ParsedCertificationDeepLink {
  const values = new URLSearchParams(search).getAll("certificationId");
  if (values.length === 0) return { present: false, certificationId: null, invalid: false };
  if (values.length !== 1 || !/^[1-9]\d*$/.test(values[0])) {
    return { present: true, certificationId: null, invalid: true };
  }

  const certificationId = Number(values[0]);
  if (!isPositiveSafeInteger(certificationId)) {
    return { present: true, certificationId: null, invalid: true };
  }

  return { present: true, certificationId, invalid: false };
}

export function applyCertificationDeepLinkToSearch(search: string, certificationId: number): string {
  if (!isPositiveSafeInteger(certificationId)) return removeCertificationDeepLinkFromSearch(search);
  const params = new URLSearchParams(search);
  params.set("tab", "certificaciones");
  params.set("certificationId", String(certificationId));
  return `?${params.toString()}`;
}

export function removeCertificationDeepLinkFromSearch(search: string): string {
  const params = new URLSearchParams(search);
  params.delete("certificationId");
  const query = params.toString();
  return query ? `?${query}` : "";
}

export function getContractCertificationDeepLink(input: {
  customerPartnerId: number;
  contractId: number;
  certificationId: number;
}): string | null {
  if (
    !isPositiveSafeInteger(input.customerPartnerId) ||
    !isPositiveSafeInteger(input.contractId) ||
    !isPositiveSafeInteger(input.certificationId)
  ) return null;

  const query = new URLSearchParams({
    tab: "certificaciones",
    certificationId: String(input.certificationId),
  });
  return `/customers/${input.customerPartnerId}/contracts/${input.contractId}?${query.toString()}`;
}
